export enum GameMessagePlacement {
    CENTER,
    BOTTOM,
    TOP,
    ABSOLUTE,
}
